// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion_list__tdVil {
  border-top: 1px solid var(--color-border);
  font-family: var(--font-sans);
}
.accordion_item__oSdgd {
  border-bottom: 1px solid var(--color-border);
}
.accordion_heading__klwAg {
  margin: 0;
}
.accordion_trigger__qy28y {
  width: 100%;
  display: grid;
  grid-template-columns: 2.5rem minmax(0, 1fr) 1.5rem;
  align-items: center;
  gap: var(--space-3);
  padding: 1.35rem 0;
  background: none;
  border: 0;
  text-align: left;
  font-family: var(--font-sans);
  color: var(--color-text);
  cursor: pointer;
}
.accordion_index__UPjaI {
  font-size: var(--text-caption);
  font-weight: 700;
  color: var(--kur-amber);
  font-variant-numeric: tabular-nums;
}
.accordion_title__Qvo7S {
  font-size: clamp(1.1rem, 1rem + 0.5vw, 1.35rem);
  font-weight: 500;
  line-height: 1.3;
  transition: color var(--dur-fast) ease;
}
.accordion_trigger__qy28y:hover .accordion_title__Qvo7S {
  color: var(--color-slate);
}
.accordion_icon__kOtoO {
  position: relative;
  width: 1.1rem;
  height: 1.1rem;
  justify-self: end;
}
.accordion_icon__kOtoO::before,
.accordion_icon__kOtoO::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 2px;
  margin-top: -1px;
  background: currentColor;
  transition: transform var(--dur) var(--ease-out);
}
.accordion_icon__kOtoO::after {
  transform: rotate(90deg);
}
.accordion_item__oSdgd[data-open="true"] .accordion_icon__kOtoO::after {
  transform: rotate(0deg);
}
.accordion_panel__f2JnG {
  overflow: hidden;
}
.accordion_body__Jfu3C {
  padding: 0 0 1.5rem calc(2.5rem + var(--space-3));
  max-width: 48rem;
  line-height: var(--leading-body);
  color: var(--color-text-muted);
}
.accordion_body__Jfu3C p {
  margin: 0 0 0.75rem;
}

.accordion_dark__ClZRr {
  border-top-color: var(--color-border-on-dark);
}
.accordion_dark__ClZRr .accordion_item__oSdgd {
  border-bottom-color: var(--color-border-on-dark);
}
.accordion_dark__ClZRr .accordion_trigger__qy28y {
  color: #fff;
}
.accordion_dark__ClZRr .accordion_trigger__qy28y:hover .accordion_title__Qvo7S {
  color: var(--kur-gold);
}
.accordion_dark__ClZRr .accordion_body__Jfu3C {
  color: var(--color-text-muted-on-dark);
}

@media (max-width: 600px) {
  .accordion_trigger__qy28y {
    grid-template-columns: 2rem minmax(0, 1fr) 1.25rem;
  }
  .accordion_body__Jfu3C {
    padding-left: calc(2rem + var(--space-3));
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/ACCORDION/accordion.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,6BAA6B;AAC/B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,mDAAmD;EACnD,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,gDAAgD;AAClD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,kDAAkD;EACpD;EACA;IACE,yCAAyC;EAC3C;AACF","sourcesContent":[".list {\n  border-top: 1px solid var(--color-border);\n  font-family: var(--font-sans);\n}\n.item {\n  border-bottom: 1px solid var(--color-border);\n}\n.heading {\n  margin: 0;\n}\n.trigger {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 2.5rem minmax(0, 1fr) 1.5rem;\n  align-items: center;\n  gap: var(--space-3);\n  padding: 1.35rem 0;\n  background: none;\n  border: 0;\n  text-align: left;\n  font-family: var(--font-sans);\n  color: var(--color-text);\n  cursor: pointer;\n}\n.index {\n  font-size: var(--text-caption);\n  font-weight: 700;\n  color: var(--kur-amber);\n  font-variant-numeric: tabular-nums;\n}\n.title {\n  font-size: clamp(1.1rem, 1rem + 0.5vw, 1.35rem);\n  font-weight: 500;\n  line-height: 1.3;\n  transition: color var(--dur-fast) ease;\n}\n.trigger:hover .title {\n  color: var(--color-slate);\n}\n.icon {\n  position: relative;\n  width: 1.1rem;\n  height: 1.1rem;\n  justify-self: end;\n}\n.icon::before,\n.icon::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  height: 2px;\n  margin-top: -1px;\n  background: currentColor;\n  transition: transform var(--dur) var(--ease-out);\n}\n.icon::after {\n  transform: rotate(90deg);\n}\n.item[data-open=\"true\"] .icon::after {\n  transform: rotate(0deg);\n}\n.panel {\n  overflow: hidden;\n}\n.body {\n  padding: 0 0 1.5rem calc(2.5rem + var(--space-3));\n  max-width: 48rem;\n  line-height: var(--leading-body);\n  color: var(--color-text-muted);\n}\n.body p {\n  margin: 0 0 0.75rem;\n}\n\n.dark {\n  border-top-color: var(--color-border-on-dark);\n}\n.dark .item {\n  border-bottom-color: var(--color-border-on-dark);\n}\n.dark .trigger {\n  color: #fff;\n}\n.dark .trigger:hover .title {\n  color: var(--kur-gold);\n}\n.dark .body {\n  color: var(--color-text-muted-on-dark);\n}\n\n@media (max-width: 600px) {\n  .trigger {\n    grid-template-columns: 2rem minmax(0, 1fr) 1.25rem;\n  }\n  .body {\n    padding-left: calc(2rem + var(--space-3));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `accordion_list__tdVil`,
	"item": `accordion_item__oSdgd`,
	"heading": `accordion_heading__klwAg`,
	"trigger": `accordion_trigger__qy28y`,
	"index": `accordion_index__UPjaI`,
	"title": `accordion_title__Qvo7S`,
	"icon": `accordion_icon__kOtoO`,
	"panel": `accordion_panel__f2JnG`,
	"body": `accordion_body__Jfu3C`,
	"dark": `accordion_dark__ClZRr`
};
export default ___CSS_LOADER_EXPORT___;
